__webpack_require__.p = "/wp-content/themes/sofia-custom-theme/react-app/";